import classnames from "classnames";
import { Location } from "history";
import React from 'react';
import {Link, useLocation, useRouteMatch} from "react-router-dom";
import {
    hasCBPermission,
    hasHRUPermission,
    hasPWVPermission,
    hasStoryboardPermission,
    hasRetinalMarketTrends,
    hasVestrumPracticePerformanceTracker, hasQBPermission
} from '../actions/userSlice';
import { useAppSelector } from '../hooks';
import { ReactComponent as CohortTrackerIcon } from '../pages/homepage/icons/svg/Cohort-Tracker.svg';
import { ReactComponent as HomeIcon } from '../pages/homepage/icons/svg/Home.svg';
import { ReactComponent as HruIcon } from '../pages/homepage/icons/svg/HRU.svg';
import { ReactComponent as PathwayViewerIcon } from '../pages/homepage/icons/svg/PWV.svg';
import { ReactComponent as StoryboardIcon } from '../pages/homepage/icons/svg/Storyboard.svg';
import { ReactComponent as RetinaMarketTrendsIcon } from '../pages/homepage/icons/svg/Retinal-Market-Trends.svg';
import { ReactComponent as QueryBuilderIcon } from '../pages/homepage/icons/svg/QB-Icon.svg';
import { Routes } from "../pages/routes";
import { Setting } from "../types/AppState";
import styles from './LeftMenu.module.scss';

const MenuItem = ({title, route, hasPermission, isActive, children}: {
    title: string,
    route: string,
    hasPermission?: boolean | Setting,
    isActive: boolean,
    children: JSX.Element
}) => {
    if (!hasPermission) {
        return null;
    }

    return <Link to={route}>
        <div className={classnames("logo", {active: isActive})}>
            {children}
            <span className={classnames('label', styles.label)}>{title}</span>
        </div>
    </Link>
}

const Home = () => {
    return <MenuItem
        title="Home"
        route={Routes.Home}
        isActive={false}
        hasPermission
    >
        <HomeIcon className={styles.menuIcon}/>
    </MenuItem>
}

const CohortBuilder = ({location}: {location: Location}) => {
    const permission = useAppSelector(hasCBPermission)
    const match = useRouteMatch<{projectId: string}>(Routes.Project)
    return <MenuItem
        title="Cohort Builder"
        route={Routes.Projects}
        hasPermission={permission}
        isActive={location.pathname === Routes.Projects || match?.params.projectId !== undefined}
    >
        <CohortTrackerIcon className={styles.menuIcon} />
    </MenuItem>
}

const HRU = ({location}: {location: Location}) => {
    const permission = useAppSelector(hasHRUPermission)
    return <MenuItem
        title="HRU"
        route={Routes.MyStudiesHRU}
        hasPermission={permission}
        isActive={location.pathname === Routes.MyStudiesHRU || location.pathname === Routes.MyHRU}
    >
        <HruIcon className={styles.menuIcon} />
    </MenuItem>
}


const PWV = ({location}: {location: Location}) => {
    const permission = useAppSelector(hasPWVPermission)
    return <MenuItem
        title="PWV"
        route={Routes.MyStudiesPWV}
        hasPermission={permission}
        isActive={location.pathname === Routes.MyStudiesPWV || location.pathname === Routes.MyPWV}
    >
        <PathwayViewerIcon className={styles.menuIcon} />
    </MenuItem>
}

const Storyboard = ({location}: {location: Location}) => {
    const permission = useAppSelector(hasStoryboardPermission)
    return <MenuItem
        title="Storyboard"
        route={Routes.Storyboard}
        hasPermission={permission}
        isActive={location.pathname === Routes.Storyboard}
    >
        <StoryboardIcon className={styles.menuIcon} />
    </MenuItem>
}
const RetinaMarketTrends = ({location}: {location: Location}) => {
    const permission = useAppSelector(hasRetinalMarketTrends)
    return <MenuItem
        title="Retina Market Trends"
        route={Routes.RetinaMarketTrends}
        hasPermission={permission}
        isActive={location.pathname === Routes.RetinaMarketTrends}
    >
        <RetinaMarketTrendsIcon className={styles.menuIcon} />
    </MenuItem>
}
const VestrumPracticePerformanceTracker = ({location}: {location: Location}) => {
    const permission = useAppSelector(hasVestrumPracticePerformanceTracker)
    return <MenuItem
        title="Vestrum Practice Performance Tracker"
        route={Routes.VestrumPracticePerformanceTracker}
        hasPermission={permission}
        isActive={location.pathname === Routes.VestrumPracticePerformanceTracker}
    >
        <RetinaMarketTrendsIcon className={styles.menuIcon} />
    </MenuItem>
}
const QueryBuilder = ({location}: {location: Location}) => {
    const permission = useAppSelector(hasQBPermission)
    return <MenuItem
        title="Query Builder"
        route={Routes.QueryBuilderV2}
        hasPermission={permission}
        isActive={location.pathname === Routes.QueryBuilderV2}
    >
        <QueryBuilderIcon className={styles.menuIcon} />
    </MenuItem>
}

const LeftMenu = () => {
    const location = useLocation();

    return (
        <div className="left-sidebar">
            <Home/>
            <CohortBuilder location={location}/>
            <QueryBuilder location={location}/>
            <HRU location={location}/>
            <PWV location={location}/>
            <Storyboard location={location}/>
            <RetinaMarketTrends location={location}/>
            <VestrumPracticePerformanceTracker location={location}/>
        </div>
    )
}

export default LeftMenu